import flatpickr from "flatpickr/dist/flatpickr";

function initializeFlatpickr() {
  let elements = document.querySelectorAll('.datepicker');
  let options = {
    dateFormat: "d/m/Y",
    minDate: "today",
    onChange: function (selectedDates, dateStr, instance) {
      if (dateStr) {
        instance.input.parentElement.classList.add('has-value');
      } else {
        instance.input.parentElement.classList.remove('has-value');
      }
    }
  };

  elements.forEach(element => {
    if (element._flatpickr) {
      element._flatpickr.destroy();
    }
    flatpickr(element, { ...options, ...element.dataset });
  });
}

// Handle the case where an input field is cleared manually by the user
document.addEventListener('input', function (event) {
  if (event.target.matches('.datepicker')) {
    if (event.target.value) {
      event.target.parentElement.classList.add('has-value');
    } else {
      event.target.parentElement.classList.remove('has-value');
    }
  }
});

export default initializeFlatpickr;

// import flatpickr from "flatpickr/dist/flatpickr";

// // document.addEventListener('turbolinks:load', () => {

// //   let elements = document.querySelectorAll('.datepicker');
// //   let options = { dateFormat: "d/m/Y", minDate: "today" }; // default options
// //   for (let element of elements) {
// //     flatpickr(element, {...options, ...element.dataset})
// //   }
// // })

// // Function to initialize flatpickr
// function initializeFlatpickr() {
//   let elements = document.querySelectorAll('.datepicker');
//   let options = {
//     dateFormat: "d/m/Y",
//     minDate: "today",
//     onChange: function (selectedDates, dateStr, instance) {
//       // Toggle has-value class based on input value
//       if (dateStr) {
//         instance.input.parentElement.classList.add('has-value');
//       } else {
//         instance.input.parentElement.classList.remove('has-value');
//       }
//     }
//   };

//   for (let element of elements) {
//     if (element._flatpickr) {
//       element._flatpickr.destroy();
//     }
//     flatpickr(element, { ...options, ...element.dataset });
//   }
// }

// // DOMContentLoaded event listener
// // document.addEventListener('DOMContentLoaded', () => {
// //   setTimeout(initializeFlatpickr, 400);
// // });

// // Turbolinks load event listener
// document.addEventListener('turbolinks:load', () => {
//   setTimeout(initializeFlatpickr, 100);
// });

// // Handle the case where an input field is cleared manually by the user
// document.addEventListener('input', function (event) {
//   if (event.target.matches('.datepicker')) {
//     if (event.target.value) {
//       event.target.parentElement.classList.add('has-value');
//     } else {
//       event.target.parentElement.classList.remove('has-value');
//     }
//   }
// });
